import { render, staticRenderFns } from "./SliderToggle.vue?vue&type=template&id=15b872ca&scoped=true&"
import script from "./SliderToggle.vue?vue&type=script&lang=js&"
export * from "./SliderToggle.vue?vue&type=script&lang=js&"
import style0 from "./SliderToggle.vue?vue&type=style&index=0&id=15b872ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b872ca",
  null
  
)

export default component.exports